// pathsApi.js — calls /api/paths/* and /api/signup/* endpoints
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

export async function fetchPathCatalogue() {
  const { data } = await axios.get(`${API}/paths/catalogue`);
  return data.paths;
}

// ───────── Phase-9: lean /api/my/* endpoints ─────────
export async function fetchMyState() {
  const { data } = await axios.get(`${API}/my/state`);
  return data;
}
export async function fetchMyPrimaryPreviews() {
  const { data } = await axios.get(`${API}/my/primary-previews`);
  return data;
}
export async function fetchMyDiscoveryPreviews() {
  const { data } = await axios.get(`${API}/my/discovery-previews`);
  return data;
}
export async function updatePrimaryPreviews(preview_ids) {
  const { data } = await axios.post(`${API}/my/primary-previews/update`, { preview_ids });
  return data;
}
export async function updateDiscoveryPath(path_key) {
  const { data } = await axios.post(`${API}/my/discovery-path/update`, { path_key });
  return data;
}
export async function updateDiscoveryPreviews(preview_ids) {
  const { data } = await axios.post(`${API}/my/discovery-previews/update`, { preview_ids });
  return data;
}

export async function fetchUserTypes() {
  const { data } = await axios.get(`${API}/paths/user-types`);
  return data; // { user_types, mapping }
}

export async function setDiscoveryPath(path_key) {
  const { data } = await axios.post(`${API}/paths/discovery`, { path_key });
  return data;
}
// kept for backward compatibility — Phase-8 endpoint now replaces rather than appends
export const addDiscoveryPath = setDiscoveryPath;

export async function clearDiscoveryPath() {
  const { data } = await axios.delete(`${API}/paths/discovery`);
  return data;
}
// kept for backward compatibility
export async function removeDiscoveryPath(_path_key) {
  return clearDiscoveryPath();
}

export async function fetchMyPaths() {
  const { data } = await axios.get(`${API}/paths/me`);
  return data;
}

export async function addSelection(payload) {
  const { data } = await axios.post(`${API}/paths/select`, payload);
  return data;
}

export async function removeSelection(path_key, item_id) {
  const { data } = await axios.delete(`${API}/paths/select`, { params: { path_key, item_id } });
  return data;
}

// Path-specific data
export async function fetchJobRolesData() {
  const { data } = await axios.get(`${API}/paths/job_roles/data`);
  return data;
}
export async function findJobRoles(payload) {
  const { data } = await axios.post(`${API}/paths/job_roles/find`, payload);
  return data.matches;
}
export async function fetchSpecBranches(program) {
  const { data } = await axios.get(`${API}/paths/specializations/branches`, { params: { program } });
  return data.branches;
}
export async function fetchSpecData(program, branch) {
  const { data } = await axios.get(`${API}/paths/specializations/data`, { params: { program, branch } });
  return data.specializations;
}
export async function fetchAIDepartments() {
  const { data } = await axios.get(`${API}/paths/ai_pathway/departments`);
  return data.departments;
}
export async function fetchBankingBlueFamilies(domain) {
  const { data } = await axios.get(`${API}/paths/banking_bluecollar/families`, { params: { domain } });
  return data;
}
export async function fetchBankingBlueData(domain, family) {
  const { data } = await axios.get(`${API}/paths/banking_bluecollar/data`, { params: { domain, family } });
  return data;
}
export async function fetchEntrepreneurshipData() {
  const { data } = await axios.get(`${API}/paths/entrepreneurship/data`);
  return data;
}
export async function fetchClarityQuiz(track) {
  const { data } = await axios.get(`${API}/paths/after_10th_inter/quiz`, { params: { track } });
  return data;
}
export async function fetchClarityAttempts(track) {
  const { data } = await axios.get(`${API}/paths/after_10th_inter/attempts`, { params: { track } });
  return data;
}
export async function submitClarity(payload) {
  const { data } = await axios.post(`${API}/paths/after_10th_inter/submit`, payload);
  return data;
}
